import { Download, CheckSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CleaningHabitTrackerDownload = () => {
  const handleDownload = () => {
    // We create a printable PDF or an image-based tracker
    // For now, we'll open a print dialog or download a generated PDF
    window.print();
  };

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-2xl p-6 md:p-8 my-8 text-center max-w-2xl mx-auto">
      <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <CheckSquare className="w-8 h-8 text-primary" />
      </div>
      <h3 className="text-2xl font-bold mb-3">Free Cleaning Habit Tracker</h3>
      <p className="text-muted-foreground mb-6">
        Download our printable daily and weekly habit tracker to keep your home consistently clean between professional visits.
      </p>
      
      <div className="hidden print:block text-left mb-8">
        <h1 className="text-3xl font-bold mb-6 text-center">Uplevel Cleaning - Habit Tracker</h1>
        
        <div className="grid grid-cols-2 gap-8">
          <div>
            <h2 className="text-xl font-bold mb-4 border-b pb-2">Daily Habits</h2>
            <ul className="space-y-4">
              <li className="flex items-center gap-3"><div className="w-6 h-6 border-2 border-black rounded-sm"></div> Make the bed</li>
              <li className="flex items-center gap-3"><div className="w-6 h-6 border-2 border-black rounded-sm"></div> Wipe kitchen counters</li>
              <li className="flex items-center gap-3"><div className="w-6 h-6 border-2 border-black rounded-sm"></div> Load/unload dishwasher</li>
              <li className="flex items-center gap-3"><div className="w-6 h-6 border-2 border-black rounded-sm"></div> 10-minute quick tidy</li>
              <li className="flex items-center gap-3"><div className="w-6 h-6 border-2 border-black rounded-sm"></div> Wipe bathroom sinks</li>
            </ul>
          </div>
          <div>
            <h2 className="text-xl font-bold mb-4 border-b pb-2">Weekly Habits</h2>
            <ul className="space-y-4">
              <li className="flex items-center gap-3"><div className="w-6 h-6 border-2 border-black rounded-sm"></div> Vacuum high-traffic areas</li>
              <li className="flex items-center gap-3"><div className="w-6 h-6 border-2 border-black rounded-sm"></div> Mop kitchen/bathrooms</li>
              <li className="flex items-center gap-3"><div className="w-6 h-6 border-2 border-black rounded-sm"></div> Dust main surfaces</li>
              <li className="flex items-center gap-3"><div className="w-6 h-6 border-2 border-black rounded-sm"></div> Take out all trash</li>
              <li className="flex items-center gap-3"><div className="w-6 h-6 border-2 border-black rounded-sm"></div> Clean toilets & showers</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 text-center text-sm text-gray-500">
          <p>Book your next deep clean at www.uplevelcleaning.com</p>
        </div>
      </div>

      <Button 
        onClick={handleDownload}
        size="lg" 
        className="font-bold text-lg px-8 print:hidden"
      >
        <Download className="mr-2 w-5 h-5" /> Download Printable Tracker
      </Button>
    </div>
  );
};
